import React from "react";
import { Col, Input } from "reactstrap";
import { useSpecificationContextUpdater } from "./useSpecificationContextUpdater";

export default function ColPromptCheckBox({
  title,
  valuePRP,
  onChangeStringPRP,
  alignPRP,
  sizePRP,
}) {
  const SpecUpdater = useSpecificationContextUpdater();
  const alignment = !alignPRP ? "left" : alignPRP;

  if (!alignPRP) {
    return (
      <Col
        xs={sizePRP || "3"}
        className="d-flex justify-content-between align-items-center mb-3 px-4 text-white"
      >
        <h5 style={{ textAlign: alignment }}>{title}</h5>
        <Input
          type="checkbox"
          value={valuePRP}
          onChange={() => SpecUpdater.onChange(onChangeStringPRP, !valuePRP)}
          checked={valuePRP}
        />
      </Col>
    );
  } else {
    return (
      <Col
        xs={sizePRP || "3"}
        className="d-flex justify-content-start align-items-center mb-3 px-5 text-white"
        style={{ textAlign: "left" }}
      >
        <Input
          type="checkbox"
          value={valuePRP}
          onChange={() => SpecUpdater.onChange(onChangeStringPRP, !valuePRP)}
          checked={valuePRP}
        />
        &nbsp;&nbsp;&nbsp;
        <h5 style={{ textAlign: alignment, paddingTop: "1vh" }}>{title}</h5>
      </Col>
    );
  }
}
